import $ from 'jquery';
import select2 from 'select2';

select2(); // Sort of a hack to get "side-effect" import working with vite

$('.js-article-category').select2({
  allowClear: true,
  dropdownCssClass: 'selectTwo__dropdown',
  tags: true,
  // NOTE: non-breaking space to prevent input height from collapsing
  placeholder: ' ',
  selectionCssClass: 'selectTwo__input form-control',
  width: 'resolve',
});

$('.select2').attr('data-refresh-dir', 'true');
